import { render } from "./telephoneInspection.vue?vue&type=template&id=28cee5e2&scoped=true"
import script from "./telephoneInspection.vue?vue&type=script&lang=js"
export * from "./telephoneInspection.vue?vue&type=script&lang=js"

import "./telephoneInspection.vue?vue&type=style&index=0&id=28cee5e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-28cee5e2"

export default script